/* eslint-disable import/order */
import { MenuItem, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'

import {
  downloadImportTemplate,
  fetchServiceType,
  makeRelatory,
} from '../ServiceTypeActions'
import SelectField from '../../components/SelectField'
import BaseFilter from '../../../components/hooks/BaseFilter'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import Icon from '@mdi/react'
import {
  mdiFilterMultiple,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
  mdiSwapVertical,
} from '@mdi/js'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import formComponentStyles from '../../../assets/formComponentsStyles'
import colors from '../../../assets/colors'

function Filter(props) {
  const measureType = useSelector(state => state.serviceType.measureType)
  const attendanceType = useSelector(state => state.serviceType.attendanceType)
  const serviceCategory = useSelector(
    state => state.serviceType.serviceCategory
  )

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const { classes } = props
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const filterClasses = filterStylesComponents()
  const formClasses = formComponentStyles()

  const [open, setOpen] = useState(false)

  const [form, setForm] = useState({
    measureType: '',
    serviceCategory: '',
  })

  const toggleModal = () => {
    setOpen(!open)
  }

  const measureTypeFiltered = useMemo(() => {
    if (!measureType?.length) return ''
    if (!filters?.measure_type_id) return ''
    return measureType?.find(r => r?.id == filters?.measure_type_id)
  }, [measureType, filters])

  const serviceCategoryFiltered = useMemo(() => {
    if (!serviceCategory?.length) return ''
    if (!filters?.service_category_id) return ''
    return serviceCategory?.find(r => r?.id == filters?.service_category_id)
  }, [serviceCategory, filters])

  const onSubmit = (data = form) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleChangeMeasureType = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleChangeServiceCategory = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('measure_type_id', form.measureType?.id || '')
    data.append('service_category_id', form.serviceCategory?.id || '')

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  const handleRelatoryClick = () => {
    dispatch(makeRelatory(filters))
  }

  useEffect(() => {
    if (!measureTypeFiltered) return
    setForm({ ...form, measureType: measureTypeFiltered })
  }, [measureTypeFiltered])

  useEffect(() => {
    if (!serviceCategoryFiltered) return
    setForm({ ...form, serviceCategory: serviceCategoryFiltered })
  }, [serviceCategoryFiltered])

  return (
    <>
      <BaseFilter>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item xs>
                <Grid
                  container
                  spacing={2}
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Grid item>
                    <Button
                      onClick={toggleModal}
                      style={{ color: colors.textPrimary }}
                      className={filterClasses.btnMoreFilters}
                    >
                      <Icon
                        path={mdiFilterMultiple}
                        className={classes.btnIcon}
                        size={1}
                        color={colors.secondary}
                      />
                      Filtrar
                    </Button>
                  </Grid>

                  {canCreate('tipos-servico', permissionUser) && (
                    <Grid item>
                      <IconButton
                        component={Link}
                        to="/service-type/import"
                        className={filterClasses.btnAdd}
                      >
                        <Icon
                          path={mdiSwapVertical}
                          size={1}
                          style={{ marginRight: '4px' }}
                        />
                        Importar Tipo de Serviço
                      </IconButton>
                    </Grid>
                  )}

                  <Grid item>
                    <IconButton
                      className={filterClasses.btnAdd}
                      onClick={handleRelatoryClick}
                    >
                      <Icon
                        path={mdiMicrosoftExcel}
                        size={1}
                        style={{ marginRight: '4px' }}
                      />
                      Download
                    </IconButton>
                  </Grid>

                  <Grid item>
                    {canCreate('tipos-servico', permissionUser) && (
                      <IconButton
                        className={filterClasses.btnAdd}
                        component={Link}
                        to={`/service-type/new${location.search}`}
                      >
                        <Icon
                          path={mdiNoteEditOutline}
                          size={1}
                          style={{ marginRight: '4px' }}
                        />
                        Cadastrar
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </BaseFilter>

      <BaseFilterModal
        open={open}
        handleOpen={toggleModal}
        title="Filtro"
        hiddenHelpButton
      >
        <Grid item xs={12} style={{ width: '370px' }}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography
                style={{ fontSize: '16px', fontWeight: 'normal' }}
                color={colors.primary}
              >
                Utilize os campos abaixo para encontrar <br /> um tipo de
                serviço
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid
                container
                spacing={1}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    name="name"
                    label="Nome"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.name || ''}
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    select
                    name="status"
                    label="Status"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.status || ''}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    <MenuItem value={0}>Inativo</MenuItem>
                    <MenuItem value={1}>Ativo</MenuItem>
                  </TextField>
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <SelectField
                    options={measureType}
                    setForm={handleChangeMeasureType}
                    data={form.measureType || ''}
                    variant="standard"
                    name="measureType"
                    label="Tipo de Cobrança"
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    select
                    name="attendance_type_id"
                    label="Tipo de serviço"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.attendance_type_id || ''}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {attendanceType?.map(type => (
                      <MenuItem key={type?.id} value={type?.id}>
                        {type?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <SelectField
                    options={serviceCategory}
                    setForm={handleChangeServiceCategory}
                    data={form.serviceCategory || null}
                    name="serviceCategory"
                    variant="standard"
                    label="Categoria"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Button
                    type="submit"
                    color={colors.primary}
                    variant="contained"
                    className={formClasses.btnSubmmit}
                  >
                    <SearchIcon />
                    {` Pesquisar`}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </>
  )
}

export default Filter
